module.exports = __webpack_public_path__ + "img/logo_zapp.0433b369.png";